export default __webpack_public_path__ + "img/dcbRinvr.ebb4c09c.svg";